import { setSafeInnerHTML } from './htmlSecurityModule.js';

export function createReaderOrchestrator(context = {}) {
  const {
    elements,
    getReaderLifecycleModuleApi,
    ensureReaderLifecycleModuleReady,
    getReaderProgressModuleApi,
    ensureReaderProgressModuleReady,
    getReaderTocModuleApi,
    ensureReaderTocModuleReady,
    getReaderTocSearchModuleApi,
    ensureReaderTocSearchModuleReady,
    getReaderUiPanelsModuleApi,
    bindReaderOverlayOutsideCloseFallback,
    togglePanelFallback,
    closeAllPanelsFallback,
    clearTocSearchFallback,
    toggleTocFallback,
    showToast
  } = context;

  let overlayFallbackBound = false;

  async function openBook(bookId) {
    try {
      const mod = await ensureReaderLifecycleModuleReady();
      await mod?.openBook?.(bookId);
    } catch (error) {
      showToast?.('阅读器模块加载失败');
    }
  }

  async function openBookAtLocation(bookId, location) {
    try {
      const mod = await ensureReaderLifecycleModuleReady();
      await mod?.openBookAtLocation?.(bookId, location);
    } catch (error) {
      showToast?.('阅读器模块加载失败');
    }
  }

  function closeReader() {
    if (getReaderLifecycleModuleApi()?.closeReader) {
      getReaderLifecycleModuleApi().closeReader();
      return;
    }
    ensureReaderLifecycleModuleReady()
      .then((mod) => {
        mod?.closeReader?.();
      })
      .catch(() => {
        showToast?.('阅读器模块加载失败');
      });
  }

  async function navigatePage(direction) {
    const mod = await ensureReaderProgressModuleReady();
    await mod?.navigatePage?.(direction);
  }

  function updateProgressDisplay() {
    if (getReaderProgressModuleApi()?.updateProgressDisplay) {
      getReaderProgressModuleApi().updateProgressDisplay();
      return;
    }
    ensureReaderProgressModuleReady()
      .then((mod) => {
        mod?.updateProgressDisplay?.();
      })
      .catch(() => {});
  }

  async function saveCurrentProgress() {
    const mod = await ensureReaderProgressModuleReady();
    await mod?.saveCurrentProgress?.();
  }

  async function loadToc() {
    try {
      const mod = await ensureReaderTocModuleReady();
      await mod?.loadToc?.();
    } catch (error) {
      if (elements.tocList) {
        setSafeInnerHTML(elements.tocList, '<p class="toc-empty">加载目录失败</p>', { profile: 'app' });
      }
    }
  }

  function clearTocSearch() {
    if (getReaderTocSearchModuleApi()?.clearTocSearch) {
      getReaderTocSearchModuleApi().clearTocSearch();
      return;
    }
    clearTocSearchFallback(elements);
  }

  function toggleToc() {
    if (getReaderTocModuleApi()?.toggleToc) {
      getReaderTocModuleApi().toggleToc();
      return;
    }
    toggleTocFallback({
      elements,
      closeAllPanels,
      clearTocSearch,
      ensureReaderTocModuleReady
    });
  }

  async function handleTocSearch(e) {
    if (getReaderTocSearchModuleApi()?.handleTocSearch) {
      return getReaderTocSearchModuleApi().handleTocSearch(e);
    }
    try {
      const mod = await ensureReaderTocSearchModuleReady();
      return mod?.handleTocSearch?.(e);
    } catch (error) {
    }
  }

  function closeAllPanels() {
    if (getReaderUiPanelsModuleApi()?.closeAllPanels) {
      getReaderUiPanelsModuleApi().closeAllPanels();
      return;
    }
    closeAllPanelsFallback(elements);
  }

  function togglePanel(panelId) {
    if (getReaderUiPanelsModuleApi()?.togglePanel) {
      getReaderUiPanelsModuleApi().togglePanel(panelId);
      return;
    }
    togglePanelFallback(panelId, closeAllPanels);
  }

  function setupReaderOverlayOutsideCloseEvents() {
    if (getReaderUiPanelsModuleApi()?.setupReaderOverlayOutsideCloseEvents) {
      getReaderUiPanelsModuleApi().setupReaderOverlayOutsideCloseEvents();
      return;
    }
    if (overlayFallbackBound) return;
    overlayFallbackBound = true;
    bindReaderOverlayOutsideCloseFallback({
      elements,
      closeAllPanels
    });
  }

  return {
    openBook,
    openBookAtLocation,
    closeReader,
    navigatePage,
    updateProgressDisplay,
    saveCurrentProgress,
    loadToc,
    clearTocSearch,
    toggleToc,
    handleTocSearch,
    closeAllPanels,
    togglePanel,
    setupReaderOverlayOutsideCloseEvents
  };
}
